import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  referralDetails: {
    title: "",
    description: "",
    discountValue: 0,
    earnValue: 0,
    startDate: "",
    endDate: "",
    type: "",
    products: [],
    coins: "",
    points: "",
    thumbnail: "",
    coinCheck: false,
    pointCheck: false,
    platformTypes: []
  },
  bundleDetails: {
    title: "",
    description: "",
    thumbnail: "",
    coinValue: "",
    bundleValue: "",
    discount: "",
    isDiscountPercentage: false,
    taxPercentage: "",
    platformTypes: []
  },
  rewardsDetails: {
    title: "",
    description: "",
    isPublished: false,
    startDate: "",
    endDate: "",
    type: "",
    products: [],
    coins: "",
    thumbnail: "",
    platformTypes: []
  },
  offerDetails: {
    title: '',
    description: '',
    code: '',
    brandId: '',
    offerType: '',
    type: '',
    isPercentage: true,
    isLimited: false,
    value: '',
    limit: '',
    type: '',
    startDate: null,
    expiredOn: null,
    thumbnail: '',
    platformTypes: []
  }
};

export const rewardSlice = createSlice({
  name: "rewardSlice",
  initialState,
  reducers: {
    setReferralDetails: (state, { payload }) => {
      state.referralDetails = payload;
    },
    setBundleDetails: (state, { payload }) => {
      state.bundleDetails = payload;
    },
    setRewardsDetails: (state, { payload }) => {
      state.rewardsDetails = payload;
    },
    setOfferDetails: (state, { payload }) => {
      state.offerDetails = payload;
    },
    resetRewards: () => initialState
  },
});

export const { resetRewards, setReferralDetails, setBundleDetails, setRewardsDetails, setOfferDetails } = rewardSlice.actions;

export default rewardSlice.reducer;
